var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    rx: 5,
    transform: "matrix(-1 0 0 1 29 0)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0791 19.7543L13.414 14.5L19.0791 9.24564L17.3265 7.63157L9.92121 14.5L17.3265 21.3684L19.0791 19.7543Z",
    fill: "#848585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackMobile);
export default __webpack_public_path__ + "static/media/back-mobile.13b9b61c6ae9fcb93af3d66fc43ccbbe.svg";
export { ForwardRef as ReactComponent };